import React, { useState } from 'react'
import ProfileCard from '../components/ui/ProfileCard/ProfileCard'
import Ratio from 'react-bootstrap/Ratio'
import ProfileModal from '../components/ProfileModal/ProfileModal'
import { useOutletContext } from 'react-router-dom'
import Disclosure from '../components/Disclosure/Disclosure'

const BoardOfDirectors = () => {
  const { sectiondata, content } = useOutletContext() || {}
  const members = sectiondata?.members

  const [openModal, setOpenModal] = useState(false)
  const [modalData, setModalData] = useState({})

  const handleView = (cardDetail) => {
    setOpenModal(true)
    setModalData(cardDetail)
  }

  const closeModal = () => {
    setOpenModal(false)
  }

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:pt-4">
        {members?.map((member, index) => {
          return (
            <Ratio aspectRatio="1x1" key={index}>
              <ProfileCard
                cardDetail={member}
                handleView={handleView}
                topAnimation={true}
                className={'cursor-pointer'}
              />
            </Ratio>
          )
        })}
      </div>
      <Disclosure section={content?.content} />
      <ProfileModal open={openModal} data={modalData} setOpen={closeModal} />
    </>
  )
}
export default BoardOfDirectors
